import { createFileRoute } from '@tanstack/react-router';
import { CampaignAddress } from '@/pages';

export const Route = createFileRoute('/_authenticated/campaign/$id/address')({
  component: CampaignAddress,
});
